var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('inicio'),_c('nosotros'),_c('productos'),_c('clientes'),_c('conctact'),_c('foot')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }